import { useRef, useState } from 'react';
import { ScanLine, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { errMsg } from './invApi';

export const ReceiveInvoiceButton = ({ api, onDone }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const r = await api.upload('/receive', file);
      if (!r.success) {
        if (r.duplicate) toast.warning(r.error); else toast.error(r.error || 'Lecture impossible');
      } else {
        toast.success(`${r.supplier || 'Facture'} : ${r.received} pièce(s) entrée(s) au stock`);
        if (r.to_confirm) toast.warning(`${r.to_confirm} ligne(s) à confirmer dans l'onglet « À confirmer »`);
        onDone?.(r);
      }
    } catch (err) { toast.error(errMsg(err, 'Erreur de lecture de la facture')); }
    finally { setBusy(false); if (ref.current) ref.current.value = ''; }
  };

  return (
    <label className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold cursor-pointer transition-colors ${busy ? 'bg-slate-800 text-slate-400' : 'bg-amber-500 text-black hover:bg-amber-400'}`} data-testid="inventory-receive-btn">
      <input ref={ref} type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,.heic" className="hidden" onChange={handle} disabled={busy} data-testid="inventory-receive-input" />
      {busy ? <Loader2 size={16} className="animate-spin" /> : <ScanLine size={16} />}
      {busy ? 'Lecture de la facture…' : 'Recevoir une facture fournisseur'}
    </label>
  );
};
